var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modalMapaGoogle",attrs:{"titulo":"Localice su tienda","tamano":"modal-xl","no-cancelar":""},on:{"guardar":_vm.cerrarModal}},[_c('mapa-google',{ref:"GoogleMaps",attrs:{"coordenadas-entrada":_vm.coordenadas.entrada},on:{"actualizar":_vm.actualizarCoordenadas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }